export default __webpack_public_path__ + "static/media/ChevronDown.e03468db.svg";